import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const SpinLoader = (props= {}) => {
    const { fontSize = 48, color = `#00f` } = props
    const antIcon = <LoadingOutlined style={{ fontSize, color }} spin/>

    return (
        <Spin indicator={antIcon}></Spin>
    )
}

export default SpinLoader